"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Documents;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_config_1 = __importDefault(require("react-native-config"));
const Authentication_1 = __importDefault(require("../shared/Authentication"));
const react_native_1 = require("react-native");
const react_native_webview_1 = require("react-native-webview");
const UserContext_1 = require("../contexts/UserContext");
const ThemeContext_1 = require("../ThemeContext");
const react_i18next_1 = require("react-i18next");
function Documents() {
    const { t } = (0, react_i18next_1.useTranslation)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const THEME = (0, ThemeContext_1.useTheme)();
    const [redirectUrl, setRedirectUrl] = react_1.default.useState(null);
    const [loading, setLoading] = react_1.default.useState(true);
    const [error, setError] = react_1.default.useState(null);
    const { width } = (0, react_native_1.useWindowDimensions)();
    const iframePaddingLeft = width >= 1900 ? 180 :
        width >= 1700 ? 150 :
            width >= 1500 ? 120 :
                width >= 1300 ? 90 :
                    width >= 1100 ? 56 :
                        width >= 900 ? 24 :
                            12;
    const iframePaddingRight = width >= 1900 ? 180 :
        width >= 1700 ? 150 :
            width >= 1500 ? 120 :
                width >= 1300 ? 90 :
                    width >= 1100 ? 56 :
                        width >= 900 ? 24 :
                            12;
    react_1.default.useEffect(() => {
        if (!userContext?.client?.id) {
            setLoading(true);
            return;
        }
        let cancelled = false;
        const loadDocuments = async () => {
            try {
                setLoading(true);
                setError(null);
                const uri = `${react_native_config_1.default.API_URL}/sso/prism?redirectUrl=${encodeURIComponent('ess/documents')}` + `&hideNavHeader=true`;
                const token = await Authentication_1.default.GetToken();
                const response = await fetch(uri, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Nextep-Client': userContext.client.id,
                        'Nextep-Platform': react_native_1.Platform.OS === 'web' ? 'web' : 'mobile',
                    },
                });
                if (!response.ok) {
                    throw new Error(`SSO failed: ${response.status}`);
                }
                const data = await response.json();
                if (!cancelled) {
                    if (data?.redirectUrl) {
                        setRedirectUrl(data.redirectUrl);
                    }
                    else {
                        throw new Error('SSO did not return redirectUrl');
                    }
                }
            }
            catch (err) {
                if (!cancelled) {
                    console.error(err);
                    setError(err?.message ?? 'Failed to open Documents');
                }
            }
            finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };
        loadDocuments();
        return () => {
            cancelled = true;
        };
    }, [userContext?.client?.id]);
    if (loading && !redirectUrl) {
        return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Secondary, size: "large" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { marginTop: 12 }, children: t('common:messages.openingDocuments') })] }));
    }
    if (error) {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 24 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { children: error }) }));
    }
    if (!redirectUrl) {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 24 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { children: t('common:messages.unableDocuments') }) }));
    }
    if (react_native_1.Platform.OS === 'web') {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, minHeight: 0 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                    flex: 1,
                    minHeight: 0,
                    width: '100%',
                    paddingLeft: iframePaddingLeft,
                    paddingRight: iframePaddingRight,
                }, children: react_1.default.createElement('iframe', {
                    src: redirectUrl,
                    title: t('common:screenTitles.documents'),
                    style: {
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        display: 'block',
                    },
                }) }) }));
    }
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_webview_1.WebView, { source: { uri: redirectUrl }, startInLoadingState: true, overScrollMode: "never", setSupportMultipleWindows: false, javaScriptEnabled: true, domStorageEnabled: true, sharedCookiesEnabled: true, thirdPartyCookiesEnabled: true, renderLoading: () => ((0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Secondary, size: "large", style: { position: 'absolute', width: '100%', height: '100%' } })), onHttpError: () => {
                setError(t('common:messages.errorLoadingDocuments'));
            } }) }));
}
